import { render, staticRenderFns } from "./SensitiveWords.vue?vue&type=template&id=6508262e&scoped=true"
import script from "./SensitiveWords.vue?vue&type=script&lang=js"
export * from "./SensitiveWords.vue?vue&type=script&lang=js"
import style0 from "./SensitiveWords.vue?vue&type=style&index=0&id=6508262e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6508262e",
  null
  
)

export default component.exports